import styled, { css } from 'styled-components';
import theme from '../theme';
import { FunctionComponent, Suspense } from 'react';
import React from 'react';

const Content: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg className={className} x='0px' y='0px' viewBox='0 0 718.3 719'>
        <g>
            <g>
                <path
                    fill='#CBCBCB'
                    d='M1.3,360.8C1.9,163.3,162.6-0.7,366.1,2.2c192.6,2.7,356.3,160.8,353,365.8
       C716,559.7,558.4,723.3,353.3,719.8C160.9,716.5,2.2,559.7,1.3,360.8z'
                />
                <path
                    fill='#FEFEFE'
                    d='M362.5,679c-57-0.2-108.4-13.5-156.3-39.7c-31.1-17-58.4-39-82.1-65.3
       C83,528.2,57.3,474.8,46.8,414.2c-3.8-21.7-5.3-43.6-4.3-65.6c2.3-49.1,14.6-95.6,38.1-138.9c10.7-19.7,23.4-38,37.8-55.1
       c2.1-2.5,4.3-3,6.6-0.4c0.9,1,1.9,1.9,2.8,2.8c145.5,145.5,291,291,436.5,436.5c0.9,0.9,1.8,1.9,2.8,2.8c2.7,2.5,2,4.6-0.5,6.6
       c-15.2,12.7-31.3,24.2-48.5,34.1c-24.9,14.3-51.2,24.9-78.9,32c-19.1,4.8-38.4,8-58.1,9C374.1,678.5,367.2,679.1,362.5,679z'
                />
                <path
                    fill='#FEFEFE'
                    d='M678.3,361.3c-0.4,53.8-13,104.5-38.7,151.8c-10.4,19.2-22.9,37.1-37,53.8
       c-2.5,2.9-4.7,3.5-7.3,0.4c-0.9-1-1.9-1.9-2.8-2.8C447.3,419.4,302.1,274.2,157,129.1c-1.2-1.2-2.3-2.4-3.5-3.5
       c-2.4-2.3-2-4.3,0.3-6.3c23.5-20,49.3-36.4,77.4-48.9c23.4-10.4,47.7-18,72.9-22.3c24.8-4.2,49.8-5.9,75-4.3
       c29.5,1.9,58,7.4,85.9,17c35.5,12.3,67.7,30.3,96.7,54.2c38.1,31.3,67.5,69.3,88,114.1c13,28.3,21.6,58,25.6,89
       C677.2,332.4,678.4,346.8,678.3,361.3z'
                />
                <path
                    fill='#989898'
                    d='M427,489c-2.6,1.5-4.5,1.1-6.2,1.1c-82.5,0-164.9,0-247.4,0c-7.1,0-7.1,0-7.1-7.1
       c0-74.3,0-148.6,0-222.9c0-7,0.1-6.3,7.1-7.2c12.6-1.7,21.4,2.9,29.9,12.2c16.5,17.9,34.1,34.7,51.5,51.7
       c3.5,3.5,4.4,6.2,2.8,11.2c-20.4,62.9,19.8,129,84.9,139.8c17.7,2.9,35.2,1.7,52.2-4.4c3.7-1.3,6-0.8,8.7,2
       C411,473.3,418.9,480.9,427,489z'
                />
                <path
                    fill='#989898'
                    d='M362,441.9c-41-0.1-75.3-29.1-81.4-67.5c-1.4-8.6-1.5-17.2-0.1-25.9c0.2-1.3,0.2-2.9,1.6-3.4
       c1.3-0.5,2,1,2.8,1.8c29.9,29.9,59.9,59.8,89.8,89.8c0.8,0.8,2.2,1.6,1.6,2.8c-0.5,0.8-2,1.2-3.1,1.3
       C368.8,441.3,364.5,441.7,362,441.9z'
                />
                <path
                    fill='#989898'
                    d='M554.4,371.5c0,37.5,0,75,0,112.5c0,2,1.1,4.7-1.5,5.8c-2.5,1-3.9-1.4-5.3-2.9
       c-27.7-27.7-55.4-55.4-83.1-83c-2.4-2.4-3.1-4.5-2-7.9c21.8-62.7-17.9-129.7-83.6-141.5c-17.8-3.2-35.5-2-52.7,4.1
       c-3.8,1.4-6.3,0.9-9.2-2.1c-13.4-13.7-27-27.1-40.6-40.7c-1.2-1.2-3.5-2.3-2.6-4.4c0.8-2.1,3.2-1.3,4.9-1.3
       c54.3,0,108.6,0,162.9-0.1c3.7,0,5.7,1.3,7.3,4.6c5.4,11.3,11.2,22.3,16.6,33.6c1.7,3.7,3.9,5.1,8,5c24.5-0.2,49-0.1,73.5-0.1
       c7.2,0,7.3,0,7.3,7.5C554.4,297.5,554.4,334.5,554.4,371.5z'
                />
                <path
                    fill='#989898'
                    d='M441.4,361c-0.4,4.3-0.8,8.6-1.3,12.9c-0.1,1.1-0.2,2.6-1.4,3c-1.3,0.5-2-0.9-2.8-1.7
       c-7.4-7.4-14.8-14.8-22.3-22.2c-22.3-22.3-44.5-44.5-66.7-66.8c-1.1-1.1-3.3-2-2.4-3.9c0.6-1.3,2.6-1.1,4.1-1.4
       c42.6-6.3,83.1,22,91.2,65.1C440.7,351,441.4,356,441.4,361z'
                />
                <path
                    fill='#FEFEFE'
                    d='M490.2,296.1c0-11.8,9.4-21.2,21.3-21.2c12.1,0,21.8,9.7,21.6,21.5c-0.2,11.6-9.9,21.2-21.5,21.4
       C499.8,317.9,490.2,308.1,490.2,296.1z'
                />
            </g>
        </g>
    </svg>
);

const NoImage = styled(Content)`
    width: 128px;
    height: 128px;
`;

export default NoImage;
